import * as UI from "@iyk/ui"

export const Footer = () => {
  return (
    <footer className="flex flex-col gap-24 px-4 pt-24 pb-4">
      <div className="flex flex-col">
        {FOOTER_LINKS.map((link, idx) => (
          <a
            key={idx}
            href={link.href}
            className="text-sm text-gray-12 py-2.5 [&:not(:last-child)]:bshadow-b [&:not(:last-child)]:bshadow-gray-4 flex items-center justify-between"
            target="_blank"
            rel="noreferrer"
          >
            <div className="flex items-center gap-2">
              <link.logo />
              {link.label}
            </div>
            <UI.Icon.ArrowUpRight />
          </a>
        ))}
      </div>
      <a
        href="https://iyk.app"
        className="text-xs-upper text-gray-10"
        target="_blank"
        rel="noreferrer"
      >
        Powered by IYK
      </a>
    </footer>
  )
}

const FOOTER_LINKS = [
  {
    label: "Instagram",
    logo: UI.Icon.Instagram,
    href: "https://www.instagram.com/slanderofficial/",
  },
  {
    label: "Facebook",
    logo: UI.Icon.Facebook,
    href: "https://www.facebook.com/slanderofficial/",
  },
  {
    label: "YouTube",
    logo: UI.Icon.Youtube,
    href: "https://www.youtube.com/channel/UC_D7aoxoyj5drj_1PKQNyMw?feature=gws_kp_artist&feature=gws_kp_artist",
  },
  {
    label: "X",
    logo: UI.Icon.X,
    href: "https://x.com/SlanderOfficial",
  },
]
